
import Vue from 'vue';

// Components
import Button from '~/components/builders/Base/Button.vue';

// Assets
import OopsImg from '~/assets/img/welcome/oops.svg';

export default Vue.extend({
    name: 'WelcomeErrorPage',
    components: {
        Button,
    },
    data() {
        return {
            OopsImg,
        };
    },
    methods: {
        complete() {
            this.$router.replace(
                this.$URLS.profile,
                () => {
                    this.$emit('flowCompleted');
                },
                () => {
                    this.$emit('flowCompleted');
                }
            );
        },
    },
});
